import type { NavigationEnd, NavigationStart, Scroll } from '@angular/router';
import { createAction, props } from '@ngrx/store';

import type { ActivatedRouteState } from 'src/app/core/services/activated-route/activated-route-state.interface';

export enum RouterActionType {
  RouterNavigationStart = '[Router] START Navigation',
  GuardsCheckStart = '[Router] START Guards Check',
  ContextUpdated = '[Router] UPDATED Context ',
  GuardsCheckEnd = '[Router] END Guards Check',
  ResolveStart = '[Router] START Resolve',
  ResolveEnd = '[Router] END Resolve',
  RouterNavigationEnd = '[Router] END Navigation',
  RouterScroll = '[Router] Scroll',
  StoreLocationAndBaseHref = '[Router] Store Location and Base Href',
  VehicleLengthPageVisited = '[Router] Store vehicle length page visited',
  PreconfigPageVisited = '[Router] Store preconfig page visited'
}

export const routerNavigationStartAction = createAction(
  RouterActionType.RouterNavigationStart,
  props<{
    event: NavigationStart;
  }>()
);

export const routerGuardsCheckStartAction = createAction(
  RouterActionType.GuardsCheckStart,
  props<{
    routeState: ActivatedRouteState;
  }>()
);

export const routerContextUpdatedAction = createAction(
  RouterActionType.ContextUpdated,
  props<{
    routeState: ActivatedRouteState;
  }>()
);

export const routerGuardsCheckEndAction = createAction(
  RouterActionType.GuardsCheckEnd,
  props<{
    routeState: ActivatedRouteState;
  }>()
);

export const routerResolveStartAction = createAction(
  RouterActionType.ResolveStart,
  props<{
    routeState: ActivatedRouteState;
  }>()
);

export const routerResolveEndAction = createAction(
  RouterActionType.ResolveEnd,
  props<{
    routeState: ActivatedRouteState;
  }>()
);

export const routerNavigationEndAction = createAction(
  RouterActionType.RouterNavigationEnd,
  props<{
    routeState: ActivatedRouteState;
    event: NavigationEnd;
  }>()
);

export const routerScrollAction = createAction(
  RouterActionType.RouterScroll,
  props<{
    routeState: ActivatedRouteState;
    event: Scroll;
  }>()
);

export const storeLocationAndBaseHrefAction = createAction(
  RouterActionType.StoreLocationAndBaseHref,
  props<{
    location: Location;
    baseHref: string;
  }>()
);

export const storeVehicleLengthPageVisitedAction = createAction(
  RouterActionType.VehicleLengthPageVisited,
  props<{
    visited: boolean;
  }>()
);

export const storePreconfigPageVisitedAction = createAction(
  RouterActionType.PreconfigPageVisited,
  props<{
    visited: boolean;
  }>()
);
